import { ReportStatus } from '@webapp/account/src/resources/reports/reports';

import type { SelectOption } from '@webapp/common/components/select';
import { QuestionType } from '@webapp/common/resources/survey';

export const ReportStatusOptions: Array<SelectOption> = [
    { label: 'Все ответы', value: ReportStatus.ALL },
    { label: 'Завершенные', value: ReportStatus.COMPLETED },
    { label: 'Не завершенные', value: ReportStatus.NOT_COMPLETED },
];

export const TEST_QUESTIONS = [
    QuestionType.TEST_ONE_OF_LIST,
    QuestionType.TEST_FEW_OF_LIST,
    QuestionType.TEST_TEXT,
    QuestionType.TEST_RANK,
];
